export const PANELS = {
  ADMIN: 'admin',
  STUDENT_AREA: 'studentZone',
  ACCESS_CONTROL: 'accessControl'
}

export const PRODUCT_ACCESS_CONTROL_OPERATIONS = {
  RESET: 'reset',
  LOG: 'log'
}